<!-- eslint-disable no-param-reassign -->
<template>
  <div class="w-full pt-5 pb-5">
    <div class="flex">
      <back-button
        label="Back"
        @onClick="
          $router.push({
            name: 'PerformanceSettings',
            query: { activeTab: 'Templates' },
          })
        "
        variant="secondary"
        class="mr-4"
      />
      <div
        class="mt-6"
        style="border-left: 1px solid #878e99; height: 1.5rem"
      />

      <div style="width: 100px; margin-top: 0.5rem">
        <h1 class="text-xl text-left font-extrabold ml-4 mt-3">
          Settings
        </h1>
      </div>
      <div class="" style="margin-top: 1.5rem">
        <Breadcrumb
          :items="breadcrumbs"
          @onClick="handleBreadcrumbClick($event)"
        />
      </div>
    </div>

    <div style="height: 100%" class="mt-28" v-if="loading">
      <loader size="xxs" :loader-image="false" />
    </div>

    <div class="px-3" v-else>
      <div>
        <p class="text-[12px] uppercase" style="font-weight:800;">
          Performance Templates
        </p>
      </div>
      <hr class="my-3"/>

      <ValidationObserver rules="required" v-slot="{ handleSubmit }">
        <PerformanceAccordion title="Contract period " info="<p>The timeframe for employees to meet their <br/> performance goals as specified in their performance contracts.</p>">


            <div class="grid grid-cols-2 gap-10 items-center">
                     <div class="flex-1 items-center w-[300px] ">
              <CSelect placeholder="Enter" :options="contractPeriodTypeOption" v-model="contractPeriodType" label="Type" disabled
                  variant="w-full" class=" mr-2 !w-full" :rules="['required']"  style="width: 100%;"/>
          </div>
            <div class="flex-1">
            <label class="date-label"> Description</label>

            <div class=" flex items-center"
            style="border:1px solid #878E99;border-radius:5px;">

              <div class="date-flex"
              style="border-radius:0px !important;border:0px;border-right:1px solid #878E99">

                <datepicker
                placeholder="Select Year"
                style="width:100px"
                minimum-view="year"
                maximum-view="year"
                format="yyyy"
                :required="true"
                :rules="['required']"
                v-model="contractPeriodYear"
                :disabled-dates="disablePastYears"
                input-class="date-input date-input_disabled"
                />
              </div>

              <c-text
                  placeholder="Perf. agreement template"
                  class="labeldisplay"
                  style="outline: none; width:100%;border-radius:0;"
                  variant="w-full !rounded-[0] cld-input"
                  v-model="performanceTemplate.agreement_description"
                  disabled
                />
                <div class=""
                style="border-radius:0px !important;border:0px;border-left:1px solid #878E99">
                <div
                  class="inline-block px-3 py-2 rounded border border-gray-300 bg-gray-100 text-gray-700 font-bold text-lg"
                  style="width: 67px; text-align: center; height: 40px; line-height: 24px;"
                >
                  {{ displayAlphabeticalSort }}
                </div>
                </div>
            </div>


            </div>

            <div class="flex-1">
              <label class="date-label">Start Date </label>
              <div class="date-flex bg-disabled">
                <datepicker
                  placeholder="--Select Day & Month--"
                  style="width: 100%; outline: none"
                  input-class="date-input"
                  format="MMMM d, yyyy"
                  disabled
                  v-model="cycleStartDate"
                />
              </div>
            </div>

            <div class="flex-1">
              <label class="date-label"> End Date </label>
              <div class="date-flex bg-disabled">
                <datepicker
                  placeholder="--Select Day & Month--"
                  style="width: 100%; outline: none"
                  input-class="date-input"
                  format="MMMM d, yyyy"
                  disabled
                  v-model="cycleEndDate"
                  :disabled-dates="{ to: new Date(cycleStartDate) }"
                />
              </div>
            </div>
          </div>
        </PerformanceAccordion>
        <PerformanceAccordion title="Agreement Setting Period "
        info="<p>The timeframe for formal documentation between line managers and their <br/> direct reports to establish clear performance expectations,<br/> goals, and responsibilities over a specified period</p>">


            <div class="grid grid-cols-2 gap-4 my-2">

              <div class="">
                <label class="date-label">Start Date </label>
                <div class="date-flex bg-disabled">
                  <datepicker
                    placeholder="--Select Day & Month--"
                    style="width: 100%; outline: none"
                    input-class="date-input"
                    format="MMMM d, yyyy"
                    v-model="agreementStartDate"
                    disabled
                  />
                </div>
              </div>

                <div class="">
                  <label class="date-label"> End Date </label>
                  <div class="date-flex bg-disabled">
                    <datepicker
                      placeholder="--Select Day & Month--"
                      style="width: 100%; outline: none"
                      input-class="date-input"
                      format="MMMM d, yyyy"
                      v-model="agreementEndDate"
                      disabled
                      :disabled-dates="{ to: new Date(agreementStartDate) }"
                    />
                  </div>
                </div>
            </div>

             </PerformanceAccordion>

        <PerformanceAccordion title="KPAs" subtitle="KPA auto-loaded based on selected KPAs in 'Manage KPAs' " >
            <div class="flex w-full flex-wrap mt-10 items-center">

              <MultiSelectTag
                bg-color="#FFFFFF"
                v-for="(t, index) in selectedKPATags"
                size="xms"
                style="border: 1px solid #00000014;border-radius:8px;"
                :key="index"
                @close="deleteSelectedKPA(t.id)"
              >
                <div
                  class="text-jet flex flex-grow"
                  style="font-size: 14px; margin-right: 10px"
                >
                  {{ t.name }}
                </div>
            </MultiSelectTag>

    <div class="ml-auto cursor-pointer" v-if="optionsKPA && optionsKPA.length > 0">
      <span class="text-flame" @click="resetAllKpas">
        <icon icon-name="refresh" size="xs" class="inline-block text-flame" /> Reset KPAs
      </span>
    </div>
          </div>

            </PerformanceAccordion>

            <PerformanceAccordion title="Performance Appraisal(s)" info=""
            :show-frequency="true"
    :initial-frequency="templateFrequency"
    :edit-appraisal="isEditing"
    @frequency-change="updateTemplateFrequency"
    disabled
            >
            <ValidationObserver rules="required" v-slot="{ handleSubmit }">


               <div class="w-full flex flex-col">
                <div class=" grid grid-cols-3 font-bold pt-10 uppercase"
                style="color: #878E99;font:900;font-size:12px;"
                >
                    <p class="">Sequence</p>
                    <p class="">Start Date</p>
                    <p class="">End Date</p>
                </div>

                  <div
                    class="grid grid-cols-3 gap-6 mt-4 mb-7"
                    v-for="(cycle, index) in appraisal_cycles"
                    :key="index"
                  >
                    <div
                      class=""
                      v-if="cycle.name !== null"
                    >
                      <div class="flex -mt-1 mb-1">

                        <c-text
                          placeholder="--Enter Name--"
                          variant="w-full mt-1"
                          class="label w-full"

                          v-model="cycle.label"
                          label="Description"
                          :rules="['required']"
                          disabled
                        />
                      </div>
                    </div>
                    <div class="">
                      <label class="date-label"> Appraisal Starts </label>
                      <div class="date-flex bg-disabled">
                        <datepicker
                          placeholder="--Select Day & Month--"
                          style="width: 100%; outline: none"
                          input-class="date-input"
                          format="MMMM d, yyyy"
                          v-model="cycle.appraisal_starts"
                          disabled
                          :rules="['required']"
                        />
                      </div>
                    </div>
                    <div class="">
                      <label class="date-label"> Appraisal Ends </label>
                      <div class="date-flex bg-disabled">
                        <datepicker
                          placeholder="--Select Day & Month--"
                          style="width: 100%; outline: none"
                          input-class="date-input"
                          format="MMMM d, yyyy"
                          v-model="cycle.appraisal_ends"
                          disabled
                          :rules="['required']"
                          :disabled-dates="{ to: new Date(cycle.appraisal_starts) }"

                        />
                      </div>
                    </div>
                  </div>
                  <div
                    v-if="frequency === '5' && !isAgreementEnded"
                    class="text-flame font-semibold flex w-full mt-6 p-2 text-base cursor-pointer"
                    @click="handleSubmit(addAppraisal)"
                  >
                    <icon icon-name="icon-plus" class="mr-2" size="xsm" />
                    Add Another Appraisal
                  </div>
              </div>
              </ValidationObserver>
          </PerformanceAccordion>

      <PerformanceAccordion
      title="Performance Moderation (Optional)"
      v-feature-request
      :show-toggle="true"
      :add-moderator="addModerator"
      :checked="performanceTemplate.enable_moderation"
      @toggle-change="updateSettings({ enable_moderation: $event })"
      :is-open="false"
      >


      <div  class="gap-6 my-4">
        <div
          v-for="(moderator, index) in performanceTemplateModerators.moderators || []"
          :key="moderator.id"
          class="moderator-item group relative"
          draggable="true"
          @dragstart="handleDragStart(index)"
          @dragover.prevent="handleDragOver(index)"
          @drop="handleDrop(index)"
        >
          <div class="grid grid-cols-11 gap-5 mt-3">
            <div class="col-span-5 relative">
              <div class="!text-[16px]" style="font-size: 14px;margin-bottom:5px">
                {{ ordinal(index + 1) }} Moderator
              </div>
              <v-select
                :clearable="false"
                :disabled="!performanceTemplate.enable_moderation"
                label="fname"
                placeholder="search or select"
                class="style-select"
                style="height: 40px; border: none !important; outline: none !important"
                :reduce="option => option.name"
                v-model="moderator.moderator"
                @search="setAllOrgUsers"
                :options="allOrgUsers"
                :filterable="true"
              />
            </div>
            <!-- Weight Input -->
            <div class="col-span-5">
              <c-text
                placeholder="xxxxxxxxx"
                variant="w-full"
                :disabled="performanceTemplate.enable_moderation"
                label="Assign Weight %"
                :rules="['required']"
                v-model="moderator.weight"
              />
            </div>


            <div
            class="col-span-1 flex items-center justify-center  gap-3 mt-8"
            @mouse.stop
          >
          <!-- <div            @click.stop="deleteModerator(index)"
          >
          <icon
          icon-name="close" class=" text-flame cursor-pointer" size="xsm" />

          </div> -->

            <div  class="drag-handle  transition-opacity border cursor-move  !rounded-sm flex items-end p-2" style="border-radius: 4px;background:#F15A2914;border-color:#F15A2952">
              <icon icon-name="drag-icon" class=" text-flame" size="xsm" />

            </div>
          </div>
          </div>
        </div>

                 </div>

                 <div class="flex flex-row w-full mt-3">
                  <radio-button
                  :options="[{name:'Allow moderators to view other moderators scoring during the moderation phase'}]"
                  :col-span="`col-span-12

                p-4 border-dashed rounded-sm`"
                  class="text-darkPurple"
                  row-gap=" gap-x-8"
                  space-between="mr-3"
                  v-model="applyTemplate"
                  @change="setApply"
                />
                </div>
    </PerformanceAccordion>

        <PerformanceAccordion title="Apply Template To Employees"
subtitle="Select which employees can see and use this template. You can restrict this template to certain categories of employees, whether by location, function, level or designation.">


            <div class="flex flex-row w-full mt-3">
              <radio-button
                :options="template_apply"
                :col-span="`col-span-6

              p-4 border-dashed rounded-sm`"
                class="text-darkPurple"
                row-gap=" gap-x-8"
                space-between="mr-3"
                v-model="applyTemplate"
                @change="setApply"
              />
            </div>

            <hr class="mb-3"/>

            <div
              class="flex flex-col p-4 border-r border-l border-b border-dashed"
              v-if="applyTemplate === 'selected'"
            >

              <div class="w-full my-4 flex">
                <div
                  style="width: 33%; margin-right: 2%"
                  class="p-4 border flex flex-col rounded-sm"
                >
                  <p class="mt-1 mb-3 text-base font-semibold">
                    Employees By Function
                  </p>
                  <div class="flex mt-3">
                    <span class="text-sm font-semibold flex flex-grow">
                      Functions
                    </span>
                    <checkbox
                      checkbox-size="height:16px; width:16px;"
                      label="All Functions"
                      v-model="applyToAllFunction"
                    />
                  </div>
                  <CustomSelect
                    placeholder="--Select Applicable Functions--"
                    :options="functions"
                    class="w-full label"
                    :disabled="applyToAllFunction"
                    v-model="selectedFunctionResponse"
                    :required="!applyToAllFunction"
                    :rules="!applyToAllFunction ? ['required'] : []"
                    option-label="name"
                    option-value="id"
                    :existing-items="selectedFunctionTags"
                    existing-item-key="id"
                    @change="onFunctionChange"
                  />

                  <Alert
                    message="Applying to employees in all functions"
                    variant="primary"
                    :time="2"
                    style="
                      position: relative;
                      right: 0;
                      z-index: 0000;
                      top: 8px;
                      font-size: 14px;
                      width: 100%;
                      box-shadow: none;
                      background: rgba(233, 147, 35, 0.15);
                      color: #333333;
                      border: 1px solid rgba(233, 147, 35, 1);
                    "
                    v-if="applyToAllFunction"
                  />

                  <div
                    class="flex w-full flex-wrap mt-3"
                    v-if="!applyToAllFunction"
                  >
                    <MultiSelectTag
                      bg-color="#F7F7FF"
                      size="xms"
                      v-for="(functionTag, index) in selectedFunctionTags"
                      :key="index"
                      @close="deleteSelectedFunction(functionTag.id)"
                    >
                      <div
                        class="text-jet flex flex-grow"
                        style="font-size: 14px; margin-right: 10px"
                      >
                        {{ functionTag.name }}
                      </div>
                    </MultiSelectTag>
                  </div>
                </div>

                <div
                  style="width: 33%; margin-right: 2%"
                  class="p-4 border flex flex-col rounded-sm"
                >
                  <p class="mt-1 mb-3 text-base font-semibold">
                    Employees By Job Level
                  </p>
                  <div class="flex mt-3">
                    <span class="text-sm font-semibold flex flex-grow">
                      Job Levels
                    </span>
                    <checkbox
                      checkbox-size="height:16px; width:16px;"
                      label="All Job Levels"
                      v-model="applyToAllJobLevel"
                    />
                  </div>
                  <CustomSelect
                    placeholder="--Select Applicable Job Levels--"
                    :options="jobLevels"
                    class="w-full label"
                    :disabled="applyToAllJobLevel"
                    v-model="selectedLevel"
                    :required="!applyToAllJobLevel"
                    :rules="!applyToAllJobLevel ? ['required'] : []"
                    option-label="name"
                    option-value="id"
                    :existing-items="selectedLevelTags"
                    existing-item-key="id"
                    @change="onLevelChange"
                  />

                  <Alert
                    message="Applying to employees of all levels"
                    variant="primary"
                    :time="2"
                    style="
                      position: relative;
                      right: 0;
                      z-index: 0000;
                      top: 8px;
                      font-size: 14px;
                      width: 100%;
                      box-shadow: none;
                      background: rgba(233, 147, 35, 0.15);
                      color: #333333;
                      border: 1px solid rgba(233, 147, 35, 1);
                    "
                    v-if="applyToAllJobLevel"
                  />

                  <div
                    class="flex w-full flex-wrap mt-3"
                    v-if="!applyToAllJobLevel"
                  >
                    <MultiSelectTag
                      bg-color="#F7F7FF"
                      size="xms"
                      v-for="(level, index) in selectedLevelTags"
                      :key="index"
                      @close="deleteSelectedLevel(level.id)"
                    >
                      <div
                        class="text-jet flex flex-grow"
                        style="font-size: 14px; margin-right: 10px"
                      >
                        {{ level.name }}
                      </div>
                    </MultiSelectTag>
                  </div>
                </div>

                <div
                  style="width: 33%; margin-right: 0%"
                  class="p-4 border flex flex-col rounded-sm"
                >
                  <p class="mt-1 mb-3 text-base font-semibold">
                    Employees By Designation
                  </p>
                  <div class="flex mt-3">
                    <span class="text-sm font-semibold flex flex-grow">
                      Designations
                    </span>
                    <checkbox
                      checkbox-size="height:16px; width:16px;"
                      label="All Designations"
                      v-if="designations.length > 0"
                      v-model="applyToAllDesignation"
                      :disabled="disableCheckBox"
                    />
                  </div>
                  <CustomSelect
                    placeholder="--Select Applicable Designations--"
                    :options="designations"
                    class="w-full label"
                    :disabled="applyToAllDesignation"
                    v-model="selectedDesignation"
                    :required="!applyToAllDesignation && designations.length > 0"
                    :rules="!applyToAllDesignation && designations.length > 0 ? ['required'] : []"
                    option-label="name"
                    option-value="id"
                    :existing-items="appliedDesignationObjects"
                    existing-item-key="id"
                    @change="onDesignationChange"
                  />
                  <Alert
                    message="Select at least one function to be able to see all applicable designations..."
                    variant="primary"
                    :time="2"
                    style="
                      position: relative;
                      right: 0;
                      z-index: 0000;
                      top: 12px;
                      font-size: 12px;
                      width: 100%;
                      box-shadow: none;
                      background: rgba(234, 60, 83, 0.15);
                      color: #ea3c53;
                    "
                    v-if="
                      designations.length === 0 &&
                      selectedDesignationTags.length === 0
                    "
                  />
                  <div
                    class="flex w-full flex-wrap mt-3"
                    v-if="!applyToAllDesignation"
                  >
                    <MultiSelectTag
                      bg-color="#F7F7FF"
                      size="xms"
                      v-for="(designation, index) in selectedDesignationTags"
                      :key="index"
                      @close="deleteSelectedDesignation(designation.id)"
                    >
                      <div
                        class="text-jet flex flex-grow"
                        style="font-size: 14px; margin-right: 10px"
                      >
                        {{ designation.name }}
                      </div>
                    </MultiSelectTag>
                  </div>
                </div>
              </div>
            </div>
        </PerformanceAccordion>

        <div class="flex mt-5">
          <div class="flex flex-grow">
            <Button
              class="bg-dynamicBackBtn text-white text-center"
              width="8rem"
              @click="handleSubmit(handleSaveTemplate)"
              :disabled="disableBtn"
            >
              Save
            </Button>
            <Button
              background-color="none"
              class="ml-4 text-darkPurple text-center"
              width="8rem"
              @click="
                $router.push({
                  name: 'PerformanceSettings',
                  query: { activeTab: 'Templates' },
                })
              "
            >
              Cancel
            </Button>
          </div>
          <div class="flex justify-end" v-if="!isEditingView">
            <Button
              class="text-dynamicBackBtn border border-solid border-dynamicBackBtn text-center"
              width="8rem"
              @click="organizeTemplate('draft')"
              v-if="
                            performanceTemplate.status === 'draft' ||
              performanceTemplate.agreement_title !== '' ||
              performanceTemplate.agreement_description !== ''
              "
            >
              Save as Draft
            </Button>
          </div>
        </div>
      </ValidationObserver>
    </div>
  </div>
</template>

<script>
import { ValidationObserver } from "vee-validate";
import BackButton from "@scelloo/cloudenly-ui/src/components/back-button";
import Breadcrumb from "@scelloo/cloudenly-ui/src/components/bread-crumb";
import Alert from "@scelloo/cloudenly-ui/src/components/alert";
import CSelect from "@scelloo/cloudenly-ui/src/components/select";
import CustomSelect from '@/components/CustomSelect'
import Datepicker from "vuejs-datepicker";
import CText from "@scelloo/cloudenly-ui/src/components/text";
import RadioButton from "@/components/RadioButton";
import Checkbox from "@/components/Checkbox";
import MultiSelectTag from "@/components/MultiSelectTag";
import Button from "@/components/Button";
import paramsMixin from '@/utilities/paramsMixin';
import timeFormatMixin from "@/utilities/timeFormatMixin";
import PerformanceAccordion from './PerformanceAccordion';
import "vue-select/dist/vue-select.css";

export default {
  name: "EditLinkedTemplate",
  mixins: [paramsMixin, timeFormatMixin],
  components: {
    ValidationObserver,
    BackButton,
    Checkbox,
    MultiSelectTag,
    Breadcrumb,
    Alert,
    Button,
    Datepicker,
    RadioButton,
    CSelect,
    CustomSelect,
    CText,
    PerformanceAccordion,
    vSelect: () => import("vue-select"),

  },

  data() {
    return {
      templateFrequency: '',
      isEditing: false,
      breadcrumbs: [
        {
          disabled: false,
          text: "Settings",
          href: "Settings",
          id: "Settings",
        },
        {
          disabled: false,
          text: "Performance",
          href: "PerformanceSettings",
          id: "Performance",
        },
        {
          disabled: false,
          text: "Template",
          href: "PerformanceSettings",
          id: "Performance",
        },
        {
          disabled: false,
          text: "Performance Template",
          href: "PerformanceSettings",
          id: "Template",
        }
      ],
      performanceTemplateModerators: {
        enable_moderation: false,
        moderators: [
          { id: 1, moderator: null, weight: '' },
          { id: 2, moderator: null, weight: '' }
        ]
      },
      moderators: [
  { id: 1, moderator: null, weight: '' },
  { id: 2, moderator: null, weight: '' }
],
      moderator_allow: [
        {
          name: "Allow moderators to view other moderators scoring during the moderation phase",
          radioName: "allow_moderator",
          value: "all",
        }
      ],
      template_apply: [
        {
          name: "Apply to Selected Employees",
          radioName: "template_right",
          value: "selected",
        },
      ],
      documentation_apply: [
        {
          name: "Manager to document",
          radioName: "document",
          value: "manager",
        },
        {
          name: "Employee to document",
          radioName: "document",
          value: "employee",
        },
        { name: "Both", radioName: "document", value: "both" },
      ],
      contractPeriodTypeOption: [
        { id: 1, name: "Annual" },
        { id: 2, name: "Special Project" },

      ],
      contractPeriodType: '1',
      optionsPeriod: [
        { id: 1, name: "Annual" },
        { id: 2, name: "Bi-Annual" },
        { id: 4, name: "Quarterly" },
        { id: 5, name: "Custom" },
      ],
      alphabetOptions: [
      { id: 'A', name: 'A' },
      { id: 'B', name: 'B' },
      { id: 'C', name: 'C' },
      { id: 'D', name: 'D' },
      { id: 'E', name: 'E' },
      { id: 'F', name: 'F' },
      { id: 'G', name: 'G' },
      { id: 'H', name: 'H' },
      { id: 'I', name: 'I' },
      { id: 'J', name: 'J' },
      { id: 'K', name: 'K' },
      { id: 'L', name: 'L' },
      { id: 'M', name: 'M' },
      { id: 'N', name: 'N' },
      { id: 'O', name: 'O' },
      { id: 'P', name: 'P' },
      { id: 'Q', name: 'Q' },
      { id: 'R', name: 'R' },
      { id: 'S', name: 'S' },
      { id: 'T', name: 'T' },
      { id: 'U', name: 'U' },
      { id: 'V', name: 'V' },
      { id: 'W', name: 'W' },
      { id: 'X', name: 'X' },
      { id: 'Y', name: 'Y' },
      { id: 'Z', name: 'Z' }
    ],
      optionsVal: "1",
      AnnualAppraisal: [
        {
          value: "Mid-Year Review",
          label: "Final Appraisal",
        },
      ],
      BiAppraisal: [
        {
          value: "Mid-Year Review",
          label: "First Appraisal",
        },
        {
          value: "Final Appraisal",
          label: "Final Appraisal",
        },
      ],
      QAppraisal: [
        {
          value: "Q1 Appraisal",
          label: "First Appraisal",
        },
        {
          value: "Q2 Appraisal",
          label: "Second Appraisal",
        },
        {
          value: "Q3 Appraisal",
          label: "Third Appraisal",
        },
        {
          value: "Q4 Appraisal",
          label: "Final Appraisal",
        },
      ],
      disabledDates: {
        from: "",
        to: "", // Disable all dates up to specific date
      },
      disableModerationDates: {
        from: "",
        to: "",
      },
      disableBtn: false,
      appraisalEndDate: "",
      loading: true,
      setModeration: false,
      applyTemplate: "all",
      selectedKPA: "",
      selectedKPATags: [],
      optionsKPA: [],
      kpaTypes: [],
      locations: [],
      selectedLocation: "",
      selectedLocationTags: [],
      jobLevels: [],
      selectedLevel: "",
      selectedLevelTags: [],
      functions: [],
      selectedFunctionResponse: "",
      selectedFunctionTags: [],
      designations: [],
      disableCheckBox: false,
      allDesignations: [],
      filteredDesignations: [],
      selectedDesignation: "",
      selectedDesignationTags: [],
      pendingDesignationIds: [],
      applyToAllLocation: false,
      applyToAllJobLevel: false,
      applyToAllFunction: false,
      applyToAllDesignation: false,
      performanceTemplate: {
        orgId: null,
        title: "",
        linkId:"",
        performance_template_status: "draft",
        kpa_types: [],
        appraisalCycleId: "",
        agreement_title: "",
        agreement_description: "",
        status: "draft",
        performance_agreement: {
          title: "",
          appraisal_frequency: "Annual",
          cycle_start_date: "",
          cycle_end_date: "",
          description: "",
          appraisalCycleId: "",
          appraisal_cycles: [],
        },
        enable_moderation: false,
        functional_moderation_start: "",
        functional_moderation_end: "",
        ceo_moderation_start: "",
        ceo_moderation_end: "",
        appliedTemplateTo: {
          applyToAllLocation: true,
          locationIds: [],
          applyToAllJobLevel: true,
          jobLevelIds: [],
          applyToAllFunction: true,
          functionIds: [],
          applyToAllDesignation: true,
          designationIds: [],
        },
      },
      frequency: null,
      payloadFrequency: "",
      alphabeticalSort: "A",
      appraisal_cycles: [],
      cycleStartDate: "",
      contractPeriodYear: new Date().getFullYear().toString(),
      cycleEndDate: "",
      agreementStartDate: "",
      agreementEndDate: "",
      functionalStart: "",
      functionalEnd: "",
      ceoStart: "",
      ceoEnd: "",
      weightRules: [
        "required",
        {
          name: "value",
          rule: (w) => this.validateWeight(w),
        },
      ],
      locationRules: [
        {
          name: "value",
          rule: (l) => this.validateLocation(l),
        },
      ],
      activeTab: "Cycles",
      kpaModal: false,
      tabsItems: [
        "Cycles",
        "Agreement Templates",
        "Targets, Ratings & Rankings",
        "Personal Development Plans",
        "Preferences",
      ],
      allOrgUsers: [],
      search:'',
      userId:'',
      draggedIndex: null,
      draggedOverIndex: null,
      cycleValidation: false,
      originalCycleData: null, // Store original cycle data for comparison
      appraisalCyclePayload: {
        orgId: "",
        appraisal_frequency: "",
        cycle_start_date: "",
        cycle_end_date: "",
        status: "active",
        agreement_start: "",
        agreement_end: "",
        appraisal_cycles: [],
      },
      appraisalCycleId : '',
      linkNo : '',
      appliedDesignations: []

    };
  },

  watch: {
    ceoStart(value) {
      this.performanceTemplate.ceo_moderation_start = this.formatDate(value);
    },

    ceoEnd(value) {
      this.performanceTemplate.ceo_moderation_end = this.formatDate(value);
    },

    functionalStart(value) {
      this.performanceTemplate.functional_moderation_start =
        this.formatDate(value);
    },

    functionalEnd(value) {
      this.performanceTemplate.functional_moderation_end =
        this.formatDate(value);
    },

    frequency(value) {
      if (this.appraisal_cycles && this.appraisal_cycles.length > 0 && this.payloadFrequency === value) {
        return;
      }

      this.appraisal_cycles = [];
      const payloadCycles =
        this.performanceTemplate.performance_agreement.appraisal_cycles;

      if (value !== "5") {
        for (let i = 0; i < value; i++) {
          this.appraisal_cycles.push({
            name:
              this.payloadFrequency === value
                ? payloadCycles[i].name
                : this.getCycleName(Number(value), i),
            label: this.payloadFrequency === value && payloadCycles[i].label
              ? payloadCycles[i].label
              : this.getCycleLabel(Number(value), i),
            checkName: false,
            appraisal_starts:
              this.payloadFrequency === value
                ? this.setDates(payloadCycles[i].appraisal_starts)
                : "",
            appraisal_ends:
              this.payloadFrequency === value
                ? this.setDates(payloadCycles[i].appraisal_ends)
                : "",
            weight:
              this.payloadFrequency === value ? payloadCycles[i].weight : "",
          });
        }
      } else if (value === "5" && this.payloadFrequency === "5") {
        for (let i = 0; i < payloadCycles.length; i++) {
          this.appraisal_cycles.push({
            name: payloadCycles[i].name,
            label: payloadCycles[i].name || payloadCycles[i].label || this.getCycleLabel(Number(value), i),
            checkName: true,
            appraisal_starts:
              payloadCycles[i].appraisal_starts === ""
                ? ""
                : this.setDates(payloadCycles[i].appraisal_starts),
            appraisal_ends:
              payloadCycles[i].appraisal_ends === ""
                ? ""
                : this.setDates(payloadCycles[i].appraisal_ends),
            weight: payloadCycles[i].weight,
            id: payloadCycles[i].id,
          });
        }
      } else {
        this.appraisal_cycles.push({
          name: "First Appraisal",
          label: this.getCycleLabel(Number(value), 0),
          checkName: true,
          appraisal_starts: "",
          appraisal_ends: "",
          weight: "",
        });
      }
    },

    applyToAllLocation(allLocation) {
      if (allLocation) {
        this.selectedLocation = "";
        this.selectedLocationTags = [];
        this.getLocation();
      }

      this.performanceTemplate.appliedTemplateTo.applyToAllLocation =
        allLocation;
    },

    selectedLocation() {
      this.locations.filter((location) => {
        if (location.id === this.selectedLocation) {
          this.selectedLocationTags.push({
            id: location.id,
            name: location.name,
          });
        }
        return {};
      });

      const disableIndex = this.locations
        .map((item) => item.id)
        .indexOf(this.selectedLocation);

      document
        .querySelectorAll("select")[2]
        .options[disableIndex + 1].setAttribute("disabled", true);
    },

    applyToAllJobLevel(allLevels) {
      if (allLevels) {
        this.selectedLevel = "";
        this.selectedLevelTags = [];
        this.getJobLevels();
      }

      this.performanceTemplate.appliedTemplateTo.applyToAllJobLevel = allLevels;
    },

    selectedLevel() {
        this.jobLevels.filter((level) => {
          if (level.id === this.selectedLevel) {
            this.selectedLevelTags.push({
              id: level.id,
              name: level.name,
            });
          }
          return {};
        });

        const disableIndex = this.jobLevels
          .map((item) => item.id)
          .indexOf(this.selectedLevel);

        document
          .querySelectorAll("select")[4]
          .options[disableIndex + 1].setAttribute("disabled", true);
        // Refresh job levels list to hide the selected one
        this.getJobLevels();
      },

    applyToAllFunction(allFunctions) {
      if (allFunctions) {

        this.selectedFunction = "";
        this.selectedFunctionTags = [];
        this.functions = [];
        this.getFunctions();
        this.getDesignations("");
      } else {
        this.designations = [];
      }

      this.performanceTemplate.appliedTemplateTo.applyToAllFunction =
        allFunctions;

      this.disableCheckBox = false;
    },

    selectedFunctionResponse() {
      this.functions.filter((f) => {
        if (f.id === this.selectedFunctionResponse) {
          this.selectedFunctionTags.push({
            id: f.id,
            name: f.name,
          });
        }
        return {};
      });
      if (this.selectedFunctionResponse !== "") {
        this.getDesignations(this.selectedFunctionResponse);
        this.applyToAllDesignation = false;
        this.disableCheckBox = true;
      }
    },
    selectedDesignation() {
        this.designations.filter((designation) => {
          if (designation.id === this.selectedDesignation) {
            this.selectedDesignationTags.push({
              id: designation.id,
              name: designation.name,
            });
          }
          return {};
        });

        const disableIndex = this.designations
          .map((item) => item.id)
          .indexOf(this.selectedDesignation);

        document
          .querySelectorAll("select")[5]
          .options[disableIndex + 1].setAttribute("disabled", true);
        this.getDesignations();
        this.syncAppliedTemplateToIds();

      },
  },
  computed: {
    isEditingView() {
        return (
          this.$route.path.includes('/edit')
        );
      },
    shouldShowFrequency() {
      return this.templateType === 'performance' || this.someOtherCondition;
    },
    filteredGroups() {
            const groups =  this.groups.filter(group => group.id !== (this.item.group?.id || null));
            return [this.addNewGroupOption, ...groups];
        },
    isAgreementEnded() {
      if (!this.cycleEndDate) return false;
      const today = new Date();
      const endDate = new Date(this.cycleEndDate);
      return today === endDate;
    },
    displayAlphabeticalSort() {
      const letters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
      if (typeof this.linkNo !== 'number' || this.linkNo < 1) return 'A';
      return letters[this.linkNo - 1] || 'A';
    },
    disablePastYears() {
      const currentYear = new Date().getFullYear();
      return {
        customPredictor: (date) => date.getFullYear() < currentYear
      };
    }
  },

  methods: {
    updateTemplateFrequency(newFrequency) {
      this.templateFrequency = newFrequency;
      this.frequency = newFrequency;
      this.appraisal_cycles = [];
      switch(newFrequency) {
        case '1': // Annual
          this.appraisal_cycles = [{
            name: 'Annual Appraisal',
            label: 'Single Appraisal',
            appraisal_starts: null,
            appraisal_ends: null,
            weight: '100',
            isLocked: false
          }];
          break;
        case '2': // BiAnnual
          this.appraisal_cycles = [
            {
              name: 'Mid-Year Review',
              label: 'First Appraisal',
              appraisal_starts: null,
              appraisal_ends: null,
              weight: '50',
              isLocked: false
            },
            {
              name: 'Final Appraisal',
              label: 'Second Appraisal',
              appraisal_starts: null,
              appraisal_ends: null,
              weight: '50',
              isLocked: false
            }
          ];
          break;
        case '5': // Custom
          this.appraisal_cycles = [{
            name: 'First Appraisal',
            label: 'Appraisal 1',
            appraisal_starts: null,
            appraisal_ends: null,
            weight: null,
            isLocked: false
          }];
          break;
        default:
          this.appraisal_cycles = [];
          break;
      }
    },

    resetAllKpas() {
      this.getKPATypes();
            this.$toasted.success('All KPAs have been reset', { duration: 3000 });
    },
    addModerator() {
      if (!this.performanceTemplate.enable_moderation) return;
            const newModerator = {
        id: Date.now(),
        moderator: null,
        weight: ''
      };
      this.performanceTemplateModerators.moderators.push(newModerator);
    },
    handleDragStart(index) {
  this.draggedIndex = index;
},
handleDragOver(index) {
  this.draggedOverIndex = index;
},
handleDrop(targetIndex) {
  if (this.draggedIndex === null) return;

  const items = [...this.performanceTemplateModerators.moderators];
  const draggedItem = items[this.draggedIndex];

  let newTargetIndex = targetIndex; // Assign to a new variable

  if (this.draggedIndex < newTargetIndex) {
    newTargetIndex -= 1;
  }

  items.splice(this.draggedIndex, 1);
  items.splice(newTargetIndex, 0, draggedItem);

  this.performanceTemplateModerators.moderators = items;

  this.draggedIndex = null;
  this.draggedOverIndex = null;
},
ordinal(n) {
  const s = ["th", "st", "nd", "rd"];
  const v = n % 100;
  return n + (s[(v - 20) % 10] || s[v] || s[0]);
},
deleteModerator(index) {
  this.performanceTemplateModerators.moderators.splice(index, 1);
},

updateSettings(newSettings) {
    Object.assign(this.performanceTemplate, newSettings);
  },
async setAllOrgUsers(search, loading) {
            loading(true);
            try {
                const attributes = "id,fname,lname,photo,userId";
                const { data } = await this.$_getAllEmployeesWithQueries(
                `search=${search}&perPage=1000&payrollStatus=active&attributes=${attributes}`
                );
                this.allOrgUsers = data.data.employees;
                loading(false);
            } catch (err) {
                throw new Error(err);
            }
        },
        handleSelect(selected) {
            this.search = selected.userDesignation.name;
        },

        isSelect(option) {
            this.userId = option.id
            return option
        },


    activateTab(tab) {
      this.activeTab = tab;
    },
  async handleSaveTemplate() {
      try {
        await this.$handlePrivilege("performance", "editTemplateUsage");
        this.organizeTemplate();
      } catch (error) {
        this.$toasted.error("You do not have permission to perform this task", {
          duration: 5000,
        });
      }
    },

    selectedFunction(val) {
      this.$nextTick(() => {
        const disableIndex = this.functions
          .map((item) => item.id)
          .indexOf(val);

        document
          .querySelectorAll("select")[3]
          .options[disableIndex + 1].setAttribute("disabled", true);
        if (val !== "") {
          this.getDesignations(val);
          this.applyToAllDesignation = false;

          this.disableCheckBox = true;
        }
      });
    },

    setApply(value) {
      this.apply = value;

      if (value === "all") {
        this.performanceTemplate.appliedTemplateTo.applyToAllJobLevel = true;
        this.performanceTemplate.appliedTemplateTo.applyToAllFunction = true;
        this.performanceTemplate.appliedTemplateTo.applyToAllLocation = true;
        this.performanceTemplate.appliedTemplateTo.applyToAllDesignation = true;
      } else {
        this.performanceTemplate.appliedTemplateTo.applyToAllJobLevel = false;
        this.performanceTemplate.appliedTemplateTo.applyToAllFunction = false;
        this.performanceTemplate.appliedTemplateTo.applyToAllLocation = false;
        this.performanceTemplate.appliedTemplateTo.applyToAllDesignation = false;
      }
    },

    addAppraisal() {
      if (!this.isAgreementEnded) return;
      const index = this.appraisal_cycles.length;
      this.appraisal_cycles.push({
        name: `Appraisal ${index + 1}`,
        label: `Appraisal ${index + 1}`,
        appraisal_starts: null,
        appraisal_ends: null,
        weight: null,
        isLocked: false
      });
    },

    validateWeight(w) {
      if (w < 0) {
        return `Value must be greater than or equal to 0`;
      }
      if (w > 0) {
        return this.watchWeightMax();
      }

      return true;
    },

    watchWeightMax() {
      let sum = 0;
      this.appraisal_cycles.map((cycle) => {
        const cycleConst = cycle;

        cycleConst.weight = Number(cycle.weight);

        sum += cycleConst.weight;
        return {};
      });

      if (sum > 100) {
        return "Total weight must not be greater than 100%";
      }

      return true;
    },

    getCycleName(type, index) {
      if (type === 1) {
        return this.AnnualAppraisal[index].value;
      }
      if (type === 2) {
        return this.BiAppraisal[index].value;
      }

      if (type === 4) {
        return this.QAppraisal[index].value;
      }

      return null;
    },

    getCycleLabel(type, index) {
      if (type === 1) {
        return this.AnnualAppraisal[index].label;
      }

      if (type === 2) {
        return this.BiAppraisal[index].label;
      }

      if (type === 4) {
        return this.QAppraisal[index].label;
      }

      if (type === 5) {
        return `Appraisal ${index + 1}`;
      }

      return null;
    },

    setAppraisalFreq(value) {
      if (value === "") {
        this.frequency = "1";
      } else {
        this.optionsPeriod.filter((freq) => {
          if (value === freq.name) {
            this.frequency = freq.id.toString();
            this.payloadFrequency = freq.id.toString();
          }
          return {};
        });
      }
    },

    async organizeTemplate(type) {
      if (!this.validateCycleData()) {
        this.$toasted.error("Please fill in all required cycle dates and appraisal information", {
          duration: 5000,
        });
        return;
      }
      const needsNewCycle = this.shouldCreateNewCycle();

      if (needsNewCycle) {
        this.createAppraisalCycle()
          .then(async (cycleId) => {
            if (cycleId) {
              this.performanceTemplate.appraisalCycleId = cycleId;
              this.appraisalCycleId = cycleId;
              this.prepareTemplateData(type);
            } else {
              // fallback: fetch latest cycle and set
              await this.getAppraisalCycle(this.performanceResponse.appraisal_cycle);
              this.prepareTemplateData(type);
            }
          })
          .catch((error) => {
            const errorMessage = error.response?.data?.message || "";
            if (errorMessage.includes("Already Exist") || errorMessage.includes("already exists")) {
              this.$toasted.info("Appraisal cycle already exists, proceeding with template creation", {
                duration: 3000,
              });
              this.getAppraisalCycle(this.performanceResponse.appraisal_cycle).then(() => {
                this.prepareTemplateData(type);
              });
            } else {
              this.$toasted.error("Failed to create appraisal cycle", {
                duration: 5000,
              });
            }
          });
      } else {
        if (!this.appraisalCycleId) {
          await this.getAppraisalCycle(this.performanceResponse.appraisal_cycle);
        }
        this.performanceTemplate.appraisalCycleId = this.appraisalCycleId;
        this.prepareTemplateData(type);
      }
    },

    shouldCreateNewCycle() {
      // Always create new cycle for new templates
      if (this.$route.params.id === "new") {
        return true;
      }

      // Create new cycle if no appraisal cycle ID exists
      if (!this.appraisalCycleId) {
        return true;
      }

      // Create new cycle if contract period year changed
      if (this.originalCycleData) {
        const contractYear = parseInt(this.contractPeriodYear, 10);
        let appraisalCycleYear = null;

        // Get year from existing cycle data
        if (this.originalCycleData.cycleStartDate) {
          appraisalCycleYear = new Date(this.originalCycleData.cycleStartDate).getFullYear();
        } else if (this.originalCycleData.cycleEndDate) {
          appraisalCycleYear = new Date(this.originalCycleData.cycleEndDate).getFullYear();
        } else if (this.originalCycleData.agreementStartDate) {
          appraisalCycleYear = new Date(this.originalCycleData.agreementStartDate).getFullYear();
        }

        // If years don't match, create new cycle
        if (appraisalCycleYear && appraisalCycleYear !== contractYear) {
          return true;
        }
      }

      return false;
    },

    prefillDefaultCycleData() {
      if (!this.originalCycleData) {
        this.originalCycleData = {
          cycleStartDate: this.cycleStartDate,
          cycleEndDate: this.cycleEndDate,
          agreementStartDate: this.agreementStartDate,
          agreementEndDate: this.agreementEndDate,
          frequency: this.frequency,
          appraisal_cycles: [...this.appraisal_cycles]
        };
      }
    },

    prepareTemplateData(type) {
      this.performanceTemplate.kpa_types = [];
      this.performanceTemplate.appliedTemplateTo.locationIds = [];
      this.performanceTemplate.appliedTemplateTo.jobLevelIds = [];
      this.performanceTemplate.appliedTemplateTo.functionIds = [];
      this.performanceTemplate.appliedTemplateTo.designationIds = [];

      delete this.performanceTemplate.performance_agreement;

      this.selectedKPATags.map((selected) => {
        this.performanceTemplate.kpa_types.push(selected.id);
        return {};
      });

      if (!this.performanceTemplate.appliedTemplateTo.applyToAllLocation) {
        this.selectedLocationTags.map((selected) => {
          this.performanceTemplate.appliedTemplateTo.locationIds.push(
            selected.id
          );
          return {};
        });
      }

      if (!this.performanceTemplate.appliedTemplateTo.applyToAllJobLevel) {
        this.selectedLevelTags.map((selected) => {
          this.performanceTemplate.appliedTemplateTo.jobLevelIds.push(
            selected.id
          );
          return {};
        });
      }

      if (!this.performanceTemplate.appliedTemplateTo.applyToAllFunction) {
        this.selectedFunctionTags.map((selected) => {
          this.performanceTemplate.appliedTemplateTo.functionIds.push(
            selected.id
          );
          return {};
        });

        if (this.performanceTemplate.appliedTemplateTo.applyToAllDesignation) {
          this.designations.map((selected) => {
            this.performanceTemplate.appliedTemplateTo.designationIds.push(
              selected.id
            );
            return {};
          });
        }
      }

      if (!this.performanceTemplate.appliedTemplateTo.applyToAllDesignation) {
        this.selectedDesignationTags.map((selected) => {
          this.performanceTemplate.appliedTemplateTo.designationIds.push(
            selected.id
          );
          return {};
        });
      }

      if (type === "draft") {
        this.saveDraft();
      } else {
        this.saveTemplate();
      }
    },

    saveTemplate() {
      if (this.$route.params.id !== "new") {
        this.performanceTemplate.isLinked = true;
      } else {
        this.performanceTemplate.isLinked = false;
        this.performanceTemplate.linkId = null;
      }
      this.performanceTemplate.performance_template_status = "active";
      this.performanceTemplate.status = "active";
      this.performanceTemplate.orgId = this.$orgId;
      this.performanceTemplate.title = this.performanceTemplate.agreement_description;
      this.performanceTemplate.appraisalCycleId = this.appraisalCycleId;
      this.performanceTemplate.agreement_title = this.performanceTemplate.agreement_description;
      this.performanceTemplate.year = new Date(this.contractPeriodYear).getFullYear();
      this.performanceTemplate.type = "annual";

      this.$_createPerfomanceTemplate(this.performanceTemplate)
        .then((response) => {
          this.$toasted.success(response.data.message, { duration: 5000 });
          this.$router.push({
            name: "PerformanceSettings",
            query: { activeTab: "Templates" },
          });
        })
        .catch((error) => {
          this.$toasted.error(error.response.data.message, { duration: 5000 });
        });
    },

    saveDraft() {
      // Set isLinked and linkId for edit mode
      if (this.$route.params.id !== "new") {
        this.performanceTemplate.isLinked = true;
      } else {
        this.performanceTemplate.isLinked = false;
        this.performanceTemplate.linkId = null;
      }
      this.performanceTemplate.performance_template_status = "draft";
      this.performanceTemplate.orgId = this.$orgId;
      this.performanceTemplate.title = this.performanceTemplate.agreement_description;
      this.performanceTemplate.agreement_title = this.performanceTemplate.agreement_description;
      this.performanceTemplate.type = "annual";
      this.performanceTemplate.appraisalCycleId = this.appraisalCycleId;
      this.performanceTemplate.year = new Date(this.contractPeriodYear).getFullYear();

      if (this.performanceTemplate.appraisalCycleId !== "") {
        this.$_createPerfomanceTemplate(this.performanceTemplate)
          .then(() => {
            this.$toasted.success("Performance Template saved as Draft", {
              duration: 5000,
            });
            this.$router.push({
              name: "PerformanceSettings",
              query: { activeTab: "Templates" },
            });
          })
          .catch((error) => {
            this.$toasted.error(error.response.data.message, { duration: 5000 });
          });
      }
      else {
        this.$toasted.error("You do not have an active Appraisal Cycle", { duration: 5000 });
      }
    },

    uniqueById(list = []) {
    return list.filter((item, index, arr) =>
      arr.findIndex(i => i.id === item.id) === index
    );
    },


    deleteSelectedDesignation(id) {
  this.selectedDesignationTags = this.selectedDesignationTags.filter(
    t => t.id !== id
  );

  const existingIndex = this.designations.findIndex(d => d.id === id);

  if (existingIndex !== -1) {
    this.$set(this.designations, existingIndex, {
      ...this.designations[existingIndex],
      disabled: false,
      isApplied: false
    });
  }

  const appliedIndex = this.appliedDesignations?.findIndex(d => d === id);
  if (appliedIndex !== -1) {
    this.appliedDesignations.splice(appliedIndex, 1);
  }

},






    deleteSelectedFunction(id) {
        const selectedIndex = this.selectedFunctionTags.findIndex(item => item.id === id);
        if (selectedIndex === -1) return;
        this.selectedFunctionTags.splice(selectedIndex, 1);

        if (this.selectedFunctionTags.length === 0) {
          this.selectedFunctionResponse = "";
          this.designations = [];
          this.selectedDesignationTags = [];
          this.getDesignations();
        } else {
          this.getDesignations();
        }

        this.getFunctions();
        this.syncAppliedTemplateToIds();
      },

      deleteSelectedLevel(id) {
        const selectedIndex = this.selectedLevelTags.findIndex(item => item.id === id);
        if (selectedIndex === -1) return;

        this.selectedLevelTags.splice(selectedIndex, 1);

        if (this.selectedLevelTags.length === 0) {
          this.selectedLevel = "";
        }

        this.getJobLevels();
        this.getDesignations();
        this.syncAppliedTemplateToIds();
      },

    deleteSelectedLocation(id) {
      const optionsIndex = this.locations.map((item) => item.id).indexOf(id);
      const selectedIndex = this.selectedLocationTags
        .map((item) => item.id)
        .indexOf(id);

      this.selectedLocationTags.splice(selectedIndex, 1);
      document
        .querySelectorAll("select")[2]
        .options[optionsIndex + 1].removeAttribute("disabled");

      if (this.selectedLocationTags.length === 0) {
        this.selectedLocation = "";
      }
    },

    deleteSelectedKPA(id) {
      const optionsIndex = this.selectedKPATags.map((item) => item.id).indexOf(id);
      const selectedIndex = this.selectedKPATags
        .map((item) => item.id)
        .indexOf(id);

      this.selectedKPATags.splice(selectedIndex, 1);
      document
        .querySelectorAll("select")[1]
        .options[optionsIndex + 1].removeAttribute("disabled");

      if (this.selectedKPATags.length === 0) {
        this.selectedKPA = "";
      }
    },

    normalizeKPA(kpaTypes) {
      this.kpaTypes = kpaTypes;
      this.selectedKPATags = [];

      kpaTypes.filter((kpa) => {
        this.selectedKPATags.push({
          id: kpa.id,
          name: kpa.name,
        });
        this.optionsKPA.push({
          id: kpa.id,
          name: kpa.name,
        });
        return {};
      });
    },
    getKPATypes() {
      this.$_getActiveKPAtypes().then((response) => {
        const kpaTypes = response.data.KpaType;
        this.normalizeKPA(kpaTypes);
      });
    },

    getLocation() {
      this.$_getHumanarLocations("").then((response) => {
        const newLocations = [];
        response.data.outlets.forEach((outlet) => {
          newLocations.push({
            id: outlet.id,
            name: outlet.name,
          });
        });
        // Remove duplicates
        const uniqueLocations = [];
        const seen = new Set();
        newLocations.forEach(location => {
          if (!seen.has(location.id)) {
            seen.add(location.id);
            uniqueLocations.push(location);
          }
        });
        // Hide already-selected
        const selectedIds = this.selectedLocationTags.map(l => l.id);
        this.locations = uniqueLocations.filter(location => !selectedIds.includes(location.id));
      });
    },

    getJobLevels() {
         this.$_getLevels().then((response) => {
           const newLevels = [];
           response.data.levels.forEach((level) => {
             newLevels.push({
               id: level.id,
               name: level.name,
             });
           });
           // Remove duplicates
           const uniqueLevels = [];
           const seen = new Set();
           newLevels.forEach(level => {
             if (!seen.has(level.id)) {
               seen.add(level.id);
               uniqueLevels.push(level);
             }
           });

           // Filter out already applied job levels from template endpoint
           const appliedLevelIds = this.performanceTemplate.appliedTemplateTo?.jobLevelIds || [];
           const filteredLevels = uniqueLevels.filter(level =>
             !appliedLevelIds.includes(level.id)
           );
           // Show filtered levels (existing ones will be disabled via existing-items prop)
           this.jobLevels = filteredLevels;

           // Update selectedLevelTags with proper names
           if (this.selectedLevelTags.length > 0) {
             this.selectedLevelTags = this.selectedLevelTags.map(tag => {
               const level = uniqueLevels.find(lvl => lvl.id === tag.id);
               return {
                 id: tag.id,
                 name: level ? level.name : 'Unknown Job Level'
               };
             });
           }
         });
       },

    getFunctions() {
      this.$_getFunctionKpis("").then((response) => {
        const newFunctions = [];
        response.data.functions.forEach((f) => {
          newFunctions.push({
            id: f.id,
            name: f.name,
          });
        });
        // Remove duplicates
        const uniqueFunctions = [];
        const seen = new Set();
        newFunctions.forEach(f => {
          if (!seen.has(f.id)) {
            seen.add(f.id);
            uniqueFunctions.push(f);
          }
        });
        // Hide already-selected
        const selectedIds = this.selectedFunctionTags.map(f => f.id);
        this.functions = uniqueFunctions.filter(f => !selectedIds.includes(f.id));
      });
    },

    getDesignations() {
  this.$_getDesignations("").then((response) => {
    const selectedFunctionIds = this.selectedFunctionTags.map(f => f.id);
    const selectedLevelIds = this.selectedLevelTags.map(l => l.id);

    const newDesignations = [];

    response.data.designations.forEach((designation) => {
      const matchesLevel =
        this.applyToAllJobLevel ||
        this.selectedLevelTags.length === 0 ||
        !designation.levelId ||
        selectedLevelIds.includes(designation.levelId);

      const matchesFunction =
        this.applyToAllFunction ||
        selectedFunctionIds.includes(designation.functionId);

      if (matchesLevel && matchesFunction) {
        newDesignations.push({
          id: designation.id,
          name: designation.name,
        });
      }
    });

    const uniqueDesignations = [];
    const seen = new Set();
    newDesignations.forEach(designation => {
      if (!seen.has(designation.id)) {
        seen.add(designation.id);
        uniqueDesignations.push(designation);
      }
    });

    const selectedIds = this.selectedDesignationTags.map(d => d.id);
    this.designations = uniqueDesignations.filter(designation => !selectedIds.includes(designation.id));
    this.allDesignations = response.data.designations;
    if (this.pendingDesignationIds && this.pendingDesignationIds.length > 0) {
      this.pendingDesignationIds.forEach(designationId => {
        const designation = response.data.designations.find(d => d.id === designationId);
        if (designation && !this.selectedDesignationTags.find(tag => tag.id === designationId)) {
          this.selectedDesignationTags.push({
            id: designation.id,
            name: designation.name,
            isApplied: true,
            disabled: true
          });
        }
      });
      this.pendingDesignationIds = [];
    }

    this.designations = this.designations.concat(this.selectedDesignationTags.map(d => ({
      id: d.id,
      name: d.name,
      isApplied: true,
      disabled: true
    })));
  });
},



    getTemplate() {
      let performanceResponse = [];

      const typeMap = {
            'annual': '1',
            'special project': '2',
          };



      if (this.$route.params.id !== "new") {
        this.$_getOneTemplate(this.$route.params.id).then((response) => {
          performanceResponse = response.data.PerformanceTemplate;

          const fetchTemplate = this.$_getOneLinkTemplate(performanceResponse.templateLinkId)
          fetchTemplate.then((res) => {
            const {data} = res.data;
            this.appliedDesignations = data.appliedDesignations;
          })

          this.performanceTemplate.templateId = this.$route.params.id;
          this.performanceTemplate.status = performanceResponse.status;
          this.performanceTemplate.linkId = performanceResponse.templateLinkId;
          this.contractPeriodType = typeMap[performanceResponse.template_link.type];

          if (performanceResponse.appliedToPerormance[0].id) {
            this.performanceTemplate.appliedTemplateTo.appliedToId =
              performanceResponse.appliedToPerormance[0].id;
          }

          this.performanceTemplate.title = performanceResponse.title;
          this.performanceTemplate.enable_moderation =
            performanceResponse.enable_moderation;

          this.linkNo = performanceResponse.linkNo

          // Use kpa_types from response directly when editing
          this.normalizeKPA(performanceResponse.kpa_types);

          this.ceoStart = performanceResponse.ceo_moderation_start ? this.setDates(
            performanceResponse.ceo_moderation_start
          ) : null;
          this.ceoEnd = performanceResponse.ceo_moderation_end ? this.setDates(performanceResponse.ceo_moderation_end) : null;
          this.functionalStart = performanceResponse.functional_moderation_start ? this.setDates(
            performanceResponse.functional_moderation_start
          ) : null;
          this.functionalEnd = performanceResponse.functional_moderation_end ? this.setDates(
            performanceResponse.functional_moderation_end
          ) : null;

          this.performanceTemplate.enable_moderation =
            performanceResponse.enable_moderation;

          this.performanceTemplate.agreement_title =
            performanceResponse.agreement_title;
          this.performanceTemplate.agreement_description =
            performanceResponse.agreement_description;

          if (performanceResponse.appliedToPerormance[0]) {
            if (
              performanceResponse.appliedToPerormance[0]
                .applyToAllDesignation &&
              performanceResponse.appliedToPerormance[0].applyToAllJobLevel &&
              performanceResponse.appliedToPerormance[0].applyToAllFunction &&
              performanceResponse.appliedToPerormance[0].applyToAllLocation
            ) {
              this.applyTemplate = "all";
            } else {
              this.applyTemplate = "selected";
              this.performanceTemplate.appliedTemplateTo.applyToAllJobLevel =
                performanceResponse.appliedToPerormance[0].applyToAllJobLevel;
              this.performanceTemplate.appliedTemplateTo.applyToAllFunction =
                performanceResponse.appliedToPerormance[0].applyToAllFunction;
              this.performanceTemplate.appliedTemplateTo.applyToAllLocation =
                performanceResponse.appliedToPerormance[0].applyToAllLocation;
              this.performanceTemplate.appliedTemplateTo.applyToAllDesignation =
                performanceResponse.appliedToPerormance[0].applyToAllDesignation;
            }

            this.performanceTemplate.appliedTemplateTo.designationIds =
            performanceResponse.appliedToPerormance[0].designationIds;


            this.applyToAllLocation =
              performanceResponse.appliedToPerormance[0].applyToAllLocation;
            this.applyToAllJobLevel =
              performanceResponse.appliedToPerormance[0].applyToAllJobLevel;
            this.applyToAllFunction =
              performanceResponse.appliedToPerormance[0].applyToAllFunction;
            this.applyToAllDesignation =
              performanceResponse.appliedToPerormance[0].applyToAllDesignation;

            if (!this.applyToAllLocation) {
              performanceResponse.appliedToPerormance[0].locationIds.map(
                (location) => {
                  this.timer = setTimeout(() => {
                    this.selectedLocation = location;
                  }, 1000);
                  return {};
                }
              );
            }

            if (!this.applyToAllJobLevel) {
              performanceResponse.appliedToPerormance[0].jobLevelIds.map(
                (levels) => {
                  this.timer = setTimeout(() => {
                    this.selectedLevel = levels;
                  }, 1000);
                  return {};
                }
              );
            }

            if (!this.applyToAllFunction) {
              performanceResponse.appliedToPerormance[0].functionIds.map(
                (func) => {
                  this.timer = setTimeout(() => {
                    this.selectedFunctionResponse = func;
                  }, 1000);
                  return {};
                }
              );
            }

            if (!this.applyToAllDesignation) {
              this.pendingDesignationIds = performanceResponse.appliedToPerormance[0].designationIds;
            }
          }

          this.getAppraisalCycle(performanceResponse.appraisal_cycle);

          this.loading = false;
        });
        this.loading = false;

      } else {
        // If new, fetch all KPA types
        this.getKPATypes();
        this.loading = false;
      }
    },

    checkTemplateEmployeeApplication() {
      switch (this.applyTemplate) {
        case "selected":
          if (
            this.applyToAllLocation &&
            this.applyToAllJobLevel &&
            this.applyToAllFunction &&
            this.applyToAllDesignation
          ) {
            this.applyTemplate = "all";
          }
          break;
        default:
          break;
      }
    },

    moderationStart(value) {
      this.disabledDates.to = new Date(value.valueOf() + 1000 * 60 * 60 * 24);
      this.disableModerationDates.to = new Date(
        value.valueOf() + 1000 * 60 * 60 * 24
      );
    },

    moderationEnd(value) {
      this.disabledDates.to = new Date(value.valueOf() + 1000 * 60 * 60 * 24);
      this.disableModerationDates.to = new Date(
        value.valueOf() + 1000 * 60 * 60 * 24
      );
    },

    formatCycleDate(value) {
      const startDate = `${value}/${new Date().getFullYear()}`;

      const [mm, dd, yyyy] = startDate.split("/");

      return new Date(`${dd}-${mm}-${yyyy}`).toISOString();
    },

    getAppraisalCycle(appraisal) {
      if (appraisal) {
          this.cycleStartDate = this.setDates(appraisal.cycle_start_date);
          this.cycleEndDate = this.setDates(appraisal.cycle_end_date);
          this.performanceTemplate.agreement_start = appraisal.agreement_start;
          this.performanceTemplate.agreement_end = appraisal.agreement_end;
          this.agreementStartDate = this.setDates(appraisal.agreement_start);
          this.agreementEndDate = this.setDates(appraisal.agreement_end);
          this.appraisalCycleId = appraisal.cycles[0].appraisalCycleId;

          // this.frequency = "1";
          let freq = '1';
          const freqMap = {
            'annual': '1',
            'bi-annual': '2',
            'quarterly': '4',
            'custom': '5',
          };
          if (appraisal.appraisal_frequency && freqMap[appraisal.appraisal_frequency.toLowerCase()]) {
            freq = freqMap[appraisal.appraisal_frequency.toLowerCase()];
          }
          this.frequency = freq;
          this.payloadFrequency = freq;
          this.templateFrequency = freq;

          // Prefill appraisal_cycles from backend cycles
          this.appraisal_cycles = [];
          if (Array.isArray(appraisal.cycles)) {
            appraisal.cycles.forEach((cycle) => {
              this.appraisal_cycles.push({
                name: cycle.name || '',
                label: cycle.name || '',
                appraisal_starts: this.setDates(cycle.appraisal_starts),
                appraisal_ends: this.setDates(cycle.appraisal_ends),
                weight: cycle.weight || '',
                isLocked: false,
                id: cycle.id || null,
              });
            });
          }

          this.originalCycleData = {
            cycleStartDate: this.cycleStartDate,
            cycleEndDate: this.cycleEndDate,
            agreementStartDate: this.agreementStartDate,
            agreementEndDate: this.agreementEndDate,
            frequency: this.frequency,
            appraisal_cycles: [...this.appraisal_cycles]
          };
          this.performanceTemplate.appraisalCycleId = appraisal.cycles[0].appraisalCycleId;

          if (appraisal.cycles.length > 0) {
            this.performanceTemplate.performance_agreement.appraisal_cycles =
              appraisal.cycles;

            let endDate = '';

            appraisal.cycles.map((cycle) => {
              endDate = cycle.appraisal_ends;
              return {};
            });

            this.appraisalEndDate = new Date(this.formatCycleDate(endDate));

            this.disabledDates.to = new Date(
              this.appraisalEndDate.valueOf() + 1000 * 60 * 60 * 24
            );
            this.disableModerationDates.to = new Date(
              this.appraisalEndDate.valueOf() + 1000 * 60 * 60 * 24
            );

            this.appraisalCycleId =
              appraisal.cycles[0].appraisalCycleId;

          }

        }

    },

    handleBreadcrumbClick(event) {
      this.$router.push({
        name: event,
      });
    },

    createAppraisalCycle() {
      return new Promise((resolve, reject) => {
        this.appraisalCyclePayload.appraisal_cycles = [];

        this.optionsPeriod.filter((freq) => {
          if (freq.id === Number(this.frequency)) {
            this.appraisalCyclePayload.appraisal_frequency = freq.name;
          }
          return {};
        });

        this.appraisalCyclePayload.status = "active";

        this.appraisal_cycles.map((cycle) => {
          this.appraisalCyclePayload.appraisal_cycles.push({
            name: cycle.name !== null ? cycle.name : "Annual Appraisal",
            appraisal_starts: this.formatDate(cycle.appraisal_starts),
            appraisal_ends: this.formatDate(cycle.appraisal_ends),
            cycleId: cycle.id,
          });
          return {};
        });

        this.appraisalCyclePayload.orgId = this.$orgId;
        this.appraisalCyclePayload.cycle_start_date = this.formatDate(this.cycleStartDate);
        this.appraisalCyclePayload.cycle_end_date = this.formatDate(this.cycleEndDate);
        this.appraisalCyclePayload.agreement_start = this.formatDate(this.agreementStartDate);
        this.appraisalCyclePayload.agreement_end = this.formatDate(this.agreementEndDate);

        this.$_createAppraisalCycle(this.appraisalCyclePayload)
          .then((response) => {
            const cycleId = response.data.AppraisalCycle?.id;
            resolve(cycleId);
          })
          .catch((error) => {
            const errorMessage = error.response?.data?.message || "";
            if (errorMessage.includes("Already Exist") || errorMessage.includes("already exists")) {
              resolve(null);
            } else {
              this.$toasted.error(error.response?.data?.message || "Failed to create appraisal cycle", {
                duration: 5000,
              });
              reject(error);
            }
          });
      });
    },

    validateCycleData() {
      if (this.frequency !== "1") {
        this.cycleValidation = this.appraisal_cycles.every(
          (item) => item.name && item.appraisal_starts && item.appraisal_ends
        );
      } else {
        this.cycleValidation = this.appraisal_cycles.every(
          (item) => item.appraisal_starts && item.appraisal_ends
        );
      }

      // Also validate that we have the basic cycle dates
      if (!this.cycleStartDate || !this.cycleEndDate || !this.agreementStartDate || !this.agreementEndDate) {
        this.cycleValidation = false;
      }

      return this.cycleValidation;
    },

    // Add new methods for CustomSelect
    onLocationChange(value, option) {
      if (value && option) {
        this.selectedLocationTags.push({
          id: option.id,
          name: option.name,
        });
        this.selectedLocation = "";
        this.getLocation();
      }
    },

    onFunctionChange(value, option) {
      if (value && option) {
        this.selectedFunctionTags.push({
          id: option.id,
          name: option.name,
        });
        this.selectedFunctionResponse = "";
        this.getFunctions();
        this.getDesignations();
        this.applyToAllDesignation = false;
        this.disableCheckBox = true;
      }
    },

    onLevelChange(value, option) {
      if (value && option) {
        this.selectedLevelTags.push({
          id: option.id,
          name: option.name,
        });
        this.selectedLevel = "";
        this.getJobLevels();
        this.getDesignations();

      }
    },

    onDesignationChange(emitValue, option) {
    const id = (option && (option.id ?? option[this.optionValue])) ?? emitValue;
    const name = (option && (option.name ?? option[this.optionLabel] ?? option.label)) ?? '';

    if (!id) return;

    const already = this.selectedDesignationTags.some(t => t.id === id);
    if (already) {
      this.selectedDesignation = null;
      return;
    }
    this.selectedDesignationTags = [
      ...this.selectedDesignationTags,
      { id, name }
    ];
    const existingIndex = this.designations.findIndex(d => d.id === id);
    if (existingIndex !== -1) {
      this.$set(this.designations, existingIndex, {
        ...this.designations[existingIndex],
        isApplied: true,
        disabled: true
      });
    } else {
      this.designations = this.uniqueById([
        ...this.designations,
        { id, name, isApplied: true, disabled: true }
      ]);
    }
    this.designations = this.uniqueById(this.designations);
    this.selectedDesignation = null;
    this.syncAppliedTemplateToIds();
 },

 syncAppliedTemplateToIds() {
        if (!this.performanceTemplate.appliedTemplateTo) {
          this.performanceTemplate.appliedTemplateTo = {
            applyToAllLocation: false,
            locationIds: [],
            applyToAllJobLevel: false,
            jobLevelIds: [],
            applyToAllFunction: false,
            functionIds: [],
            applyToAllDesignation: false,
            designationIds: []
          };
        }

        if (!this.applyToAllLocation) {
          this.performanceTemplate.appliedTemplateTo.locationIds = this.selectedLocationTags.map(l => l.id);
        } else {
          this.performanceTemplate.appliedTemplateTo.locationIds = [];
        }

        if (!this.applyToAllJobLevel) {
          this.performanceTemplate.appliedTemplateTo.jobLevelIds = this.selectedLevelTags.map(l => l.id);
        } else {
          this.performanceTemplate.appliedTemplateTo.jobLevelIds = [];
        }

        if (!this.applyToAllFunction) {
          this.performanceTemplate.appliedTemplateTo.functionIds = this.selectedFunctionTags.map(f => f.id);
        } else {
          this.performanceTemplate.appliedTemplateTo.functionIds = [];
        }

        if (this.applyToAllDesignation || !this.applyToAllDesignation) {
          this.performanceTemplate.appliedTemplateTo.designationIds = this.selectedDesignationTags.map(d => d.id);
        }

        this.performanceTemplate.appliedTemplateTo.applyToAllLocation = this.applyToAllLocation;
        this.performanceTemplate.appliedTemplateTo.applyToAllJobLevel = this.applyToAllJobLevel;
        this.performanceTemplate.appliedTemplateTo.applyToAllFunction = this.applyToAllFunction;
},

  },

  mounted() {
    this.getTemplate();
    this.getLocation();
    this.getJobLevels();
    this.getFunctions();
    if (this.$route.params.id === "new") {
      this.$nextTick(() => {
      });
    } else {
      this.getDesignations("");
    }
  },

};
</script>

<style lang="scss" scoped>
::v-deep .disabled {
  pointer-events: none;
  opacity: 0.5;
  background-color: transparent;
}
::v-deep .selected {
  background-color: #7e7e7e33 !important;
}

::v-deep .no-outline-select > span > select.cloudenly-input,
::v-deep .labeldisplay > span > input.cloudenly-input
 {
 border:0px;
 text-transform: capitalize;
}
::v-deep.no-outline-select > label,
::v-deep .labeldisplay > div > label
 {
  display: none !important;
}


.pr14{
  padding-right: 8px !important;
}

.bg-disabled {
  background-color: #eeeeee;
  color: #878e99;
}
.cld-input {
  border: 0px !important;
  border-radius: 8px !important;
}
.cardClass {
  box-shadow: none !important;
}

.input-with-icon-container {
  width: 100%;
  height: 40px;
  margin: auto;
  display: flex;
  justify-items: start;
  align-items: center;
  background-color: #F7F7FF;
  border-radius: 6px;
  border: none !important;
  outline: none !important;
}

.input-with-icon-container input{
  width: 100%;
  height: 100%;
  background-color: #F7F7FF !important;
  border: none !important;
  outline: none !important;
}


.moderator-item {
  transition: transform 0.2s ease;
}

.drag-handle {
  user-select: none;
  font-size: 1.2em;
  color: #666;
}

.moderator-item.dragging {
  opacity: 0.5;
  background: #f0f0f0;
}

.moderator-item.drop-target {
  border-top: 2px solid #3b82f6;
}
</style>
